import React, { useState } from "react";
import { Modal, Button, ListGroup } from 'react-bootstrap';
import './ErrorModal.css';

/**
 * ErrorModal component.
 * @param {ErrorModalProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
const ErrorModal = ({
    onClose,
    errorMessages = [],
    errorTitle = "Warning",
}) => {

    const [isShown, setIsShown] = useState(true);
    const messageTitleIndex = errorMessages.findIndex((message) => message.trimEnd().endsWith(":"));

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={isShown}
            onHide={() => setIsShown(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="text-warning">
                    {errorTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    messageTitleIndex !== -1 && (
                        <h5>
                            {errorMessages[messageTitleIndex]}
                        </h5>
                    )
                }
                <ul style={{ listStyleType: "unset", padding: "0 0 0 1.5rem" }}>
                    {
                        errorMessages.map((error, index) => (
                            (messageTitleIndex !== index && error) ? (
                                <li key={index}>
                                    <p style={{ fontSize: "1.02rem", fontWeight: "bold" }}>{error}</p>
                                </li>
                            ) : null
                        ))
                    }
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { setIsShown(false); onClose(); }}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorModal;

/**
 * Processes error messages and returns an array of ErrorMessage objects.
 * @param {Array.<{ description: string, status: string }>} errors - The array of error objects to process.
 * @returns {Array.<string>} The processed array of ErrorMessage objects.
 */
export const getErrorMessages = (errors) => {
    const messages = [];
    for (let index = 0; index < errors.length; index++) {
        const error = errors[index];
        messages.push(...(error.description.split(',')));
    }
    return messages;
}
/**
 * @typedef {Object} ErrorMessage
 * @property {string} title
 * @property {Array.<string>} blockers
 * @property {string} solution
 */

/**
 * Props for the ErrorModal component.
 * @typedef {Object} ErrorModalProps
 * @property {Function} onClose - Function to call when the modal is closed.
 * @property {string[]} errorMessages - Array of error messages.
 */